module.exports = __webpack_public_path__ + "./image/759ec5ffe298ff68687315ffd06b8aec.png";


//////////////////
// WEBPACK FOOTER
// ./images/social-sprites.png
// module id = 6
// module chunks = 0